<template>
  <div class="upstream">
    <steps @clickStep="changeSteps" :index="upstreamIndex" :steps="functionSteps"></steps>
    <div v-if="upstreamIndex===1" class="form-body">
      <div class="form-group">
        <label>命令字设置</label>
        <div class="d-flex align-items-start">
          <div>
            <div class="form-inline">
              <input v-model="rule.packetRule.key.pt[0]" type="text" class="form-control mr-2" placeholder="">
              <span class="mr-2">--</span>
              <input v-model="rule.packetRule.key.pt[1]" type="text" class="form-control mr-4" placeholder="">
            </div>
            <small class="text-muted">
              坐标
            </small>
          </div>
          <div class="form-group mr-4">
            <data-arr v-model="rule.packetRule.key.ct"></data-arr>
            <small class="text-muted">
              内容
            </small>
          </div>
        </div>
      </div>
    </div>

    <div v-if="upstreamIndex===2" class="form-body">
      <div class="form-group">
        <label>长度</label>
        <div class="d-flex align-items-start ">
          <div class="mr-4">
            <div class="form-inline">
              <text-input v-model="rule.packetRule.len.pt[0]"></text-input>
              <span class="mr-2">--</span>
              <text-input v-model="rule.packetRule.len.pt[1]"></text-input>
            </div>
            <small class="form-text">
              长度坐标
            </small>
          </div>
          <div class="form-group mr-4">
            <select class="form-control" v-model="rule.packetRule.len.ayl">
              <option value="" selected>解析方式</option>
            </select>
            <small class="form-text">
              长度解析方式
            </small>
          </div>
          <div class="form-group mr-4">
            <text-input v-model="rule.packetRule.len.ctStPt"></text-input>
            <small class="form-text">
              固定内容起始坐标
            </small>
          </div>
          <div class="form-group mr-4">
            <text-input v-model="rule.packetRule.len.ctCtLen"></text-input>
            <small class="form-text">
              固定内容长度
            </small>
          </div>
        </div>
      </div>
      <div class="form-group">
        <label>包头</label>
        <div class="d-flex align-items-start ">
          <div class="form-group mr-4">
            <!-- <text-input v-model="rule.packetRule.head.ct"></text-input> -->
           <data-arr v-model="rule.packetRule.head.ct"></data-arr>

            <small class="form-text">
              输入[0,255]区间内整数
            </small>
          </div>
        </div>
      </div>
      <div class="form-group">
        <label>包尾</label>
        <div class="d-flex align-items-start ">
          <div class="form-group mr-4">
            <!-- <text-input v-model="rule.packetRule.tail"></text-input> -->
           <data-arr v-model="rule.packetRule.tail"></data-arr>

            <small class="form-text">
              输入[0,255]区间内整数
            </small>
          </div>
        </div>
      </div>
      <div class="form-group">
        <label>校验码</label>
        <div class="d-flex align-items-start ">
          <div class="mr-4">
            <div class="form-inline">
              <text-input v-model="rule.packetRule.ck.pt[0]"></text-input>
              <span class="mr-2">--</span>
              <text-input v-model="rule.packetRule.ck.pt[1]"></text-input>
            </div>
            <small class="form-text">
              校验码坐标
            </small>
          </div>
          <div class="form-group mr-4">
            <select class="form-control" v-model="rule.packetRule.ck.ayl">
              <option value="" selected>解析方式</option>
            </select>
            <small class="form-text">
              校验码解析方式
            </small>
          </div>
          <div class="form-group mr-4">
            <text-input v-model="rule.packetRule.ck.ctStPt"></text-input>
            <small class="form-text">
              固定内容起始坐标
            </small>
          </div>
          <div class="form-group mr-4">
            <text-input v-model="rule.packetRule.ck.ctCtLen"></text-input>
            <small class="form-text">
              固定内容长度
            </small>
          </div>
        </div>
      </div>
    </div>
    <div v-if="upstreamIndex===3" class="form-body">
      <div class="form-group">
        <label>下行内容</label>
        <div class="d-flex align-items-start">
          <div class="form-group mr-4">
           <data-arr v-model="rule.ct"></data-arr>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import steps from './steps'
  import textInput from './text-input'
  import dataArr from './data-arr'

  export default {
    name: "dwStream",
    components: {
      steps,
      textInput,
      dataArr
    },
    watch:{
      rule:{
        handler(newValue, oldValue) {
          console.log(newValue)
          this.$emit('input',newValue);
        },
        deep: true
      }

    },
    computed:{
      rule(){
        console.log('computed')
        return this.value
      },
      type:{
        type:String
      }
    },
    props: {
      value: {
        type: Object,
        default() {
          return {
            packetRule: {
              timeout: '',//连接超时时间
              len: {
                pt: [0, 0], ayl: '', ctStPt: '', ctCtLen: '',//# 长度{ 长度坐标, 长度解析方式, 长度包含内容起始坐标，长度包含固定内容长度 }
              },
              count: '',//数据包总长度(心跳握手特有)
              'head': {'ct': [2, 3]},//包头{ 包头内容, 包头坐标 }
              'tail': [255],//包尾
              'ck': {'pt': [], 'ayl': '', 'ctStPt': 3, 'ctCtLen': 3}, // 校验码{ 校验码坐标, 校验码解析方式, 校验码校验内容起始坐标, 校验码包含固定内容长度 }
              'key': {'ct': [], pt: []}, // 功能key{ 功能key内容, 功能key坐标 }
            },
            ct:[],// 下行数据内容
          }
        }
      }

    },
    data() {
      return {
        upstreamIndex: 1,
        functionSteps: [
          {
            title: "命令字设置"
          },
          {
            title: "基础属性"
          },
          {
            title: "其他属性"
          },
        ],

      }
    },
    methods: {
      changeSteps(index) {
        this.upstreamIndex = index + 1;

      }
    }

  }
</script>

<style scoped>
  .text-input {
    width: 100px;
  }

  .form-body {
    padding: 3rem 0;
  }
</style>



// WEBPACK FOOTER //
// src/view/subSystem/downstream.vue